import { GithubService } from '@core/services/github/github.service';
import { Inject } from '@rxdi/core';
import { Component, css, html } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';
import { BaseComponent } from '@shared/base.component';
import { SocialService } from '@stradivario/graphql-server';
import { switchMap, tap } from 'rxjs/operators';

/**
 * @customElement social-login-container
 */
@Component({
  selector: 'social-login-container',
  style: css`
    .button {
      padding-bottom: 10px;
    }
  `,
  template(this: SocialComponent) {
    return html`
      <div class="button">
        <social-login-button type="github" @click=${this.loginWithGithub}> Login with GitHub </social-login-button>

        <social-login-button type="google" @click=${this.signInWithGoogle}> Signup with Google </social-login-button>
      </div>
    `;
  },
})
export class SocialComponent extends BaseComponent {
  @Inject(SocialService)
  private socialService: SocialService;

  @Inject(GithubService)
  private githubService: GithubService;

  @Router()
  private router: Router;

  private loginWithGithub() {
    this.socialService
      .signInWithGithub((provider) => {
        provider.addScope('repo');
        provider.addScope('delete_repo');
        provider.addScope('aaa');
        provider.setCustomParameters({
          allow_signup: 'false',
        });
        return provider;
      })
      .pipe(
        tap((result) => this.githubService.setGithubUserName(result.additionalUserInfo.username)),
        tap((result) => this.githubService.setAccessToken(result.credential['accessToken'])),
        switchMap((data) =>
          this.mutate({
            mutation: 'create-user-mutation.graphql',
            variables: {
              githubAccessToken: this.githubService.getAccessToken(),
              payload: { photoURL: data.user.photoURL },
            },
          })
        ),
        tap(() => this.goToProjects()),
        tap(() => this.socialService.userloggedIn())
      )
      .subscribe();
  }

  private goToProjects = () => {
    this.router.go('/projects');
  };

  private signInWithGoogle() {
    this.socialService
      .signInWithGoogle()
      .pipe(
        switchMap((data) =>
          this.mutate({
            mutation: 'create-user-mutation.graphql',
            variables: {
              /* TODO: How to get access token here when logging in with google ? Probably another screen ? */
              githubAccessToken: this.githubService.getAccessToken() ?? '',
              payload: { photoURL: data.user.photoURL },
            },
          })
        )
      )
      .subscribe(this.goToProjects);
  }
}
